import * as React from "react";
import { WarningLogo } from "../../assets/icons";

function WarningMessage({ title }) {
  return (
    <>
      <section className="container-warning">
        <div className="icon-warning">
          <WarningLogo />
        </div>
        <p className="message">{title}</p>
      </section>
      <style jsx>{`
        .container-warning {
          display: flex;
          font-size: 14px;
          color: var(--Accent-Red, #f15a61);
          font-weight: 400;
          margin-top: 2px;
          margin-bottom: 2px;
        }
        .icon-warning {
          margin-right: 8px;
        }
        .message {
          font-family: "DM Sans", sans-serif;
          flex: 1;
        }
      `}</style>
    </>
  );
}

export default WarningMessage;